import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette, breakpoints }) => ({
  searchFloaterContainer: {
    backgroundColor: palette.supporting.blue.light,
    padding: rem(24),
    border: `${rem(1)} solid ${palette.supporting.blue.main}`,
    borderRadius: rem(12),
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    [breakpoints.up('lg')]: {
      display: 'flex',
      alignItems: 'center',
    },
    order: 2,
  },
  textContainer: {
    flex: 1,
  },
  searchFloaterSubTitle: {
    color: palette.neutral[500],
    margin: `${rem(16)} 0`,
    [breakpoints.up('lg')]: {
      margin: 0,
    },
  },
}));
